import React from "react"
import styles from "./styles.scss"
import CaseStudyCTA from "components/CaseStudyCTA"
import { Parallax } from "react-parallax"
import { detect } from "detect-browser"
import cx from "classnames"

const browser = detect()

class CaseStudySection extends React.Component {
  render() {
    const { caseStudy, bioWidth } = this.props

    const isIE = browser.name === "ie"

    return (
      <Parallax strength={200} bgImage={caseStudy.previewBackground}>
        <section
          className={cx(styles.container, { [styles.defaultTint]: isIE })}
          style={
            !isIE ? { "--backgroundTint": caseStudy.primaryColor } : undefined
          }
        >
          <CaseStudyCTA caseStudy={caseStudy} bioWidth={bioWidth} />
        </section>
      </Parallax>
    )
  }
}

export default CaseStudySection



// WEBPACK FOOTER //
// ./src/pages/LandingPage/CaseStudySection/index.jsx